export const VALIDATOR = {
  NAME_PATTERN: /^[a-zA-Z0-9 _-]+$/,
  DESCRIPTION_PATTERN: /^[a-zA-Z0-9 .,!?()_'"-]+$/,
};
